// The tailwind css typography plugin can be configure via special classes.
// Learn more at https://tailwindcss.com/docs/typography-plugin
export const proseClasses = "prose prose-code:before:content-none prose-code:after:content-none"
